import { SVGProps } from 'react';

export const Warning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 12.2C7.448 12.2 7 11.752 7 11.2C7 10.648 7.448 10.2 8 10.2C8.552 10.2 9 10.648 9 11.2C9 11.752 8.552 12.2 8 12.2ZM7.2 3.2H8.8V8.8H7.2V3.2ZM8 0C3.5888 0 0 3.5888 0 8C0 12.412 3.5888 16 8 16C12.4112 16 16 12.412 16 8C16 3.5888 12.4112 0 8 0Z"
      fill="currentColor"
    />
  </svg>
);
